import type { VehicleListMapsResponse } from '@gm-commercial/rtk-clients/assets/types';
import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import type { SearchCriteria } from '~/common/models/common.model';
import {
  FleetMapSessionViewType,
  type MapFilterCriteria,
  type VehicleLocation,
} from '~/common/models/fleetMap.model';
import {
  FLEET_MAP_FILTER_EMPTY_STATE,
  type INITIAL_FLEET_MAP_STATE,
} from './fleetMapSlice.constants';

const reducerUpdateFleetMapFilters: CaseReducer<
  typeof INITIAL_FLEET_MAP_STATE,
  PayloadAction<Partial<MapFilterCriteria>>
> = (state, action) => {
  const currentFilters = state[FleetMapSessionViewType.FLEET_MAP_FILTERS];

  if (currentFilters) {
    currentFilters.filterType = {
      ...currentFilters.filterType,
      ...action.payload,
    };
  }
};

const reducerResetFleetMapFilters: CaseReducer<
  typeof INITIAL_FLEET_MAP_STATE,
  PayloadAction<void>
> = (state) => {
  const currentFilters = state[FleetMapSessionViewType.FLEET_MAP_FILTERS];

  if (currentFilters) {
    currentFilters.filterType = FLEET_MAP_FILTER_EMPTY_STATE;
  }
};

const reducerUpdateFleetMapSearch: CaseReducer<
  typeof INITIAL_FLEET_MAP_STATE,
  PayloadAction<Partial<SearchCriteria>>
> = (state, action) => {
  const currentSearch = state[FleetMapSessionViewType.FLEET_MAP_FILTERS];

  if (currentSearch) {
    currentSearch.searchCriteria = {
      ...currentSearch.searchCriteria,
      ...action.payload,
    };
  }
};

// Vehicle interaction reducers
const reducerSetSelectedVehicle: CaseReducer<
  typeof INITIAL_FLEET_MAP_STATE,
  PayloadAction<VehicleLocation | null>
> = (state, action) => {
  state[FleetMapSessionViewType.VEHICLE_INTERACTION].selectedVehicle =
    action.payload;
};

const reducerSetHoveredVehicle: CaseReducer<
  typeof INITIAL_FLEET_MAP_STATE,
  PayloadAction<VehicleLocation | null>
> = (state, action) => {
  state[FleetMapSessionViewType.VEHICLE_INTERACTION].hoveredVehicle =
    action.payload;
};

const reducerSetVehicleDetails: CaseReducer<
  typeof INITIAL_FLEET_MAP_STATE,
  PayloadAction<VehicleListMapsResponse | null>
> = (state, action) => {
  state[FleetMapSessionViewType.VEHICLE_INTERACTION].vehicleDetails =
    action.payload;
};

const reducerResetHoverState: CaseReducer<
  typeof INITIAL_FLEET_MAP_STATE,
  PayloadAction<void>
> = (state) => {
  state[FleetMapSessionViewType.VEHICLE_INTERACTION].hoveredVehicle = null;
  state[FleetMapSessionViewType.VEHICLE_INTERACTION].vehicleDetails = null;
};

const reducerSetCenterOnFleet: CaseReducer<
  typeof INITIAL_FLEET_MAP_STATE,
  PayloadAction<boolean>
> = (state, action) => {
  // Set center on fleet flag
  state[FleetMapSessionViewType.VEHICLE_INTERACTION].centerOnFleet =
    action.payload;
};

export const FLEET_MAP_REDUCERS = {
  reducerUpdateFleetMapFilters,
  reducerResetFleetMapFilters,
  reducerUpdateFleetMapSearch,
  reducerSetSelectedVehicle,
  reducerSetHoveredVehicle,
  reducerSetVehicleDetails,
  reducerResetHoverState,
  reducerSetCenterOnFleet,
};
